module.exports = __webpack_public_path__ + "/static/assets/5679cd29c517886712116060d3360592.svg";